import SlideOverView from 'core/src/views/modules/slide-over';
import template from 'text!core/src/templates/slideovers/class-activity-slide-over.mustache';

const ClassActivityFeedSlideOverView = SlideOverView.extend({
  template: template,

  templateData: function() {
    const url = window.location.protocol + '//' + window.location.host + '/notifications?via=notifications-dropdown';
    return { 'seeAllUrl': url };
  },

  events: {
    'click #notification-tab': 'notificationTab',
    'click #class-activity-tab': 'classActivity',
  },

  notificationTab: function() {
    if ($('#notification-feed').hasClass('hidden')) {
      this.hideClassActivityTab();
      this.showNotificationsTab();
    }
  },

  classActivity: function() {
    if ($('#class-activity-feed').hasClass('hidden')) {
      this.hideNotificationsTab();
      this.showClassActivityTab();
    }
  },

  hideNotificationsTab: function() {
    $('#notification-feed').addClass('hidden');
    $('#notification-tab').removeClass('active');
  },

  hideClassActivityTab: function() {
    $('#class-activity-feed').addClass('hidden');
    $('#class-activity-tab').removeClass('active');
  },

  showNotificationsTab: function() {
    $('#notification-feed').removeClass('hidden');
    $('#notification-tab').addClass('active');
  },

  showClassActivityTab: function() {
    $('#class-activity-feed').removeClass('hidden');
    $('#class-activity-tab').addClass('active');
  },
});

export default ClassActivityFeedSlideOverView;

